import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ReadProject } from "@/types/project";
import { useProjectActions } from "../hooks/useProjectActions";
import ProjectConfirmDialog from "./ProjectConfirmDialog";

interface ProjectReopenConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projectId: string;
  project?: ReadProject;
}

const ProjectReopenConfirmDialog = ({
  open,
  onOpenChange,
  projectId,
  project,
}: ProjectReopenConfirmDialogProps) => {
  const { t } = useTranslation();
  const { reopen } = useProjectActions(projectId, project);

  const confirmAction = useCallback(
    () => reopen.mutateAsync(undefined),
    [reopen],
  );

  return (
    <ProjectConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("projects.actions.reopen.confirm.title")}
      description={t("projects.actions.reopen.confirm.content")}
      cancelLabel={t("common.cancel")}
      confirmLabel={t("projects.actions.reopen.title")}
      confirmAction={confirmAction}
      confirmButtonVariant="default"
      isPending={reopen.isPending}
    />
  );
};

export default ProjectReopenConfirmDialog;
